import type { InstallRecord } from "@/runtime/events";

import { getAllRecords, putRecord } from "./db";

export async function listInstallRecords(): Promise<InstallRecord[]> {
  return getAllRecords<InstallRecord>("installs");
}

export async function saveInstallRecord(record: InstallRecord): Promise<void> {
  await putRecord("installs", record);
}
